const { host } = window.location;
const hostname = host.split(":")[0];

const isJimssoftHost = hostname.includes("jimssoft.com");
const isExxHost = hostname.includes(".exx.au");
const isSsxHost = hostname.includes(".ssx.au");
const isIpasoftHost = hostname.includes(".ipasoft.au");
const isExaccHost = hostname.includes(".exacc.au");
const isLocalDevHost = hostname === "localhost" || hostname.startsWith("127.");

function resolveJimssoftBaseDomain() {
  return hostname.replace(/^(my|www|app|s1v)\./, "");
}

function resolveJimssoftServiceUrls() {
  const baseDomain = resolveJimssoftBaseDomain();
  return {
    mainServiceUrl: `app.${baseDomain}`,
    correspondingService: `app.${baseDomain}`, // was s1v.* - dead host, see config note
    loginPortalUrl: hostname.startsWith("my.") ? hostname : `my.${baseDomain}`,
  };
}

function resolveMainServiceUrl() {
  const fromEnv = process.env.REACT_APP_MAIN_SERVICE_URL?.trim();
  if (fromEnv) {
    return fromEnv;
  }

  if (isJimssoftHost) {
    return resolveJimssoftServiceUrls().mainServiceUrl;
  }
  if (isIpasoftHost) {
    return "app.ipasoft.au";
  }
  if (isExaccHost) {
    return "app.exacc.au";
  }
  if (isExxHost) {
    return "app.exx.au";
  }
  if (isSsxHost) {
    return "app.ssx.au";
  }
  if (hostname.includes(".olivs.app")) {
    return hostname.startsWith("my.")
      ? hostname.replace(/^my\./, "app.")
      : "app.olivs.app";
  }
  if (hostname.startsWith("my.")) {
    return hostname.replace(/^my\./, "app.");
  }
  if (isLocalDevHost) {
    return process.env.REACT_APP_DEV_MAIN_SERVICE_URL?.trim() || "app.exacc.au";
  }

  return "";
}

// const loginUrl = host.replace(/^https:\/\/(www\.)?/, "");

export function resolveApiHosts(targetHostname) {
  const tenant = targetHostname.includes(".exx.au")
    ? "exx"
    : targetHostname.includes(".ssx.au")
      ? "ssx"
      : "exacc";

  return {
    apiDev1: `d1v-api.${tenant}.au`,
    apiDev1Exacc: `d1z-api.${tenant}.au`,
    apiDev2: `d2-api.${tenant}.au`,
    apiD2: `d2-api.${tenant}.au`,
    apiAuthx: `authx-api.${tenant}.au`,
    // Inbound session GUID registration. Moved off the Syd01 login API on 2026-09-22: AuthAPI now
    // serves api/v1/{lang}/session-management at the same paths, with the same response fields, so
    // this is a host change and nothing else.
    apiLogin: `authx-api.${tenant}.au`,
  };
}

const envConfig = {
  loginUrl: host,
  ...resolveApiHosts(hostname),
  correspondingService: "",
  mainServiceUrl: "",
  loginPortalUrl: "",
};

if (isExaccHost) {
  envConfig.mainServiceUrl = "app.exacc.au";
  envConfig.correspondingService = "app.exacc.au";
  envConfig.loginPortalUrl = "my.exacc.au";
} else if (isIpasoftHost) {
  envConfig.mainServiceUrl = "app.ipasoft.au";
  envConfig.correspondingService = "app.ipasoft.au";
  envConfig.loginPortalUrl = "my.ipasoft.au";
} else if (isExxHost) {
  envConfig.mainServiceUrl = "app.exx.au";
  envConfig.correspondingService = "app.exx.au";
  envConfig.loginPortalUrl = "my.exx.au";
} else if (isJimssoftHost) {
  const jimssoftUrls = resolveJimssoftServiceUrls();
  envConfig.mainServiceUrl = jimssoftUrls.mainServiceUrl;
  envConfig.correspondingService = jimssoftUrls.correspondingService;
  envConfig.loginPortalUrl = jimssoftUrls.loginPortalUrl;
} else if (isSsxHost) {
  envConfig.mainServiceUrl = "app.ssx.au";
  envConfig.correspondingService = "app.ssx.au";
  envConfig.loginPortalUrl = "my.ssx.au";
} else {
  envConfig.mainServiceUrl = resolveMainServiceUrl();
  if (hostname.startsWith("my.")) {
    envConfig.loginPortalUrl = hostname;
    envConfig.correspondingService = hostname.replace(/^my\./, "app.");
  }
}

/** https://{appHost}/{dbId}/dashboard — avoids malformed URLs when app host is missing. */
export function buildBusinessDashboardUrl(
  dbId,
  serviceHost = envConfig.mainServiceUrl,
) {
  if (!serviceHost || dbId == null || dbId === "") {
    console.error("Cannot build business dashboard URL", { serviceHost, dbId });
    return null;
  }
  return `https://${serviceHost}/${dbId}/dashboard`;
}

export default envConfig;
